import { writable } from 'svelte/store'

export const subRouteStore = writable({ routeTitle: '', subRoutePath: '' })
export const dashboardRoutes = writable({})

export function setSubRoute(routeTitle, subRoutePath) {
  subRouteStore.set({ routeTitle: routeTitle, subRoutePath: subRoutePath })
}

export function clearSubRoute() {
  subRouteStore.set({ routeTitle: '', subRoutePath: '' })
}
